import { render, staticRenderFns } from "./MaintopNav.vue?vue&type=template&id=08b89249&"
import script from "./MaintopNav.vue?vue&type=script&lang=js&"
export * from "./MaintopNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports